
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const StarterWebsitePage = lazy(() => import('../pages/services/starter-website/page'));
const BusinessWebsitePage = lazy(() => import('../pages/services/business-website/page'));
const PremiumWebsitePage = lazy(() => import('../pages/services/premium-website/page'));
const EcommercePage = lazy(() => import('../pages/services/ecommerce/page'));
const SEOServicesPage = lazy(() => import('../pages/services/seo-services/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const BellaVistaRestaurantPage = lazy(() => import('../pages/portfolio/bella-vista-restaurant/page'));
const UrbanSalonSpaPage = lazy(() => import('../pages/portfolio/urban-salon-spa/page'));
const TechFixSolutionsPage = lazy(() => import('../pages/portfolio/techfix-solutions/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogDetailPage = lazy(() => import('../pages/blog/detail/page'));
const TorontoWebDesignTipsPage = lazy(() => import('../pages/blog/toronto-web-design-tips/page'));
const VancouverWebDesignTipsPage = lazy(() => import('../pages/blog/vancouver-web-design-tips/page'));
const MontrealWebDesignTipsPage = lazy(() => import('../pages/blog/montreal-web-design-tips/page'));
const CalgaryWebDesignTipsPage = lazy(() => import('../pages/blog/calgary-web-design-tips/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const TransparencyPage = lazy(() => import('../pages/transparency/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/starter-website',
    element: <StarterWebsitePage />,
  },
  {
    path: '/services/business-website',
    element: <BusinessWebsitePage />,
  },
  {
    path: '/services/premium-website',
    element: <PremiumWebsitePage />,
  },
  {
    path: '/services/ecommerce',
    element: <EcommercePage />,
  },
  {
    path: '/services/seo-services',
    element: <SEOServicesPage />,
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/portfolio/bella-vista-restaurant',
    element: <BellaVistaRestaurantPage />,
  },
  {
    path: '/portfolio/urban-salon-spa',
    element: <UrbanSalonSpaPage />,
  },
  {
    path: '/portfolio/techfix-solutions',
    element: <TechFixSolutionsPage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/blog/toronto-web-design-tips',
    element: <TorontoWebDesignTipsPage />,
  },
  {
    path: '/blog/vancouver-web-design-tips',
    element: <VancouverWebDesignTipsPage />,
  },
  {
    path: '/blog/montreal-web-design-tips',
    element: <MontrealWebDesignTipsPage />,
  },
  {
    path: '/blog/calgary-web-design-tips',
    element: <CalgaryWebDesignTipsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/transparency',
    element: <TransparencyPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
